import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from '../settings.service';

@Injectable()
export class ConvenientCareSettingsService {
  public settings: Observable<any> = this.getConvenientCareSettings();

  constructor(private settingsService: SettingsService) {}

  public getConvenientCareSettings(): Observable<any> {
    return this.settingsService
      .getSetting('convenient_care')
      .pipe(filter((response) => !!response));
  }
}
